import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form, Row, Col, Button } from "react-bootstrap";
import { Formik } from "formik";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import logo from "../../../images/logo.png";
import { login, privacyPolicy, termAndCondition, users, verifyOtp } from "../../../const";
import { sendOtp, userSignUp } from "../../../reducers/commonReducer";

const schema = yup.object().shape({
  phone: yup
    .string()
    .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
    .required("Phone number is required"),
});

const UserRegister = () => {
  let width = window.innerWidth;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if(localStorage.getItem("x-auth-token") && localStorage.getItem("slug") === "admin"){
      navigate(`/branchs`)
    }else if (localStorage.getItem("x-auth-token") && ((localStorage.getItem("slug") === "customer") || (localStorage.getItem("slug") === "team_leader"))){
      navigate(`/chat-users`)
    }else if (localStorage.getItem("x-auth-token") && (localStorage.getItem("slug") === "branch_leader")){
      navigate(users)
    }else(
      navigate(`/`)
    )
  }, []);

  return (
    <> 
      {/* <CommonHeader /> */}
      <div className="container-fluid">
        <div className="p-5 mbl-pedding-10">
          <Row>
            <Col md={12} className="text-center">
              <img
                className={`rounded-circle border shadow ${width > 468 ? `w-10` : `w-50`}`}
                src={logo}
                alt={process.env.REACT_APP_SITE_NAME}
              />
            </Col>
          </Row>
          <Row className="justify-content-between mb-40">
            <Col md={12} className="text-center">
              <h1>Signup to start Chating!!!</h1>
              <p>
                Add your phone number. we'll send you a Verification code to
                know you're real
              </p>
            </Col>
          </Row>
          <Row>
            <Col md={4} className="m-auto">
              <Formik
                validationSchema={schema}
                onSubmit={async (values) => {
                  const apiResp = await dispatch(sendOtp(values));
                  if (apiResp?.payload?.status) {
                    localStorage.setItem("phone", values.phone);
                    navigate(verifyOtp);
                  }
                }}
                initialValues={{
                  phone: "",
                }}
              >
                {({ handleSubmit, handleChange, touched, values, errors }) => (
                  <Form className="container" onSubmit={handleSubmit}>
                    <Row className="mb-3 mt-4">
                      <Col md={12} sm={12}>
                        <Form.Group>
                          <Form.Control
                            type="text"
                            inputMode="numeric"
                            placeholder="Enter Your Mobile Number"
                            name="phone"
                            value={values.phone}
                            onChange={handleChange}
                            isInvalid={!!errors.phone}
                            className={
                              errors.phone && touched.phone && "errors"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.phone}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md={12} sm={12}>
                        <Button
                          variant="success"
                          className="bg-thememain w-100 text-black"
                          type="submit"
                        >
                          Send OTP
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={4} className="m-auto">
              <div className="d-flex flex-column gap-2">
                {process.env.REACT_APP_ANDROID_APP_LINK && (
                  <a
                    href={process.env.REACT_APP_ANDROID_APP_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn d-flex align-items-center justify-content-center gap-2 py-2"
                    style={{ border: "2px solid #3ddc84", color: "#3ddc84", borderRadius: 8, fontWeight: 600 }}
                  >
                    <i className="bi bi-android2" style={{ fontSize: 20 }}></i>
                    Download Android App
                  </a>
                )}
                {process.env.REACT_APP_IOS_APP_LINK && (
                  <a
                    href={process.env.REACT_APP_IOS_APP_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn d-flex align-items-center justify-content-center gap-2 py-2"
                    style={{ border: "2px solid #555", color: "#555", borderRadius: 8, fontWeight: 600 }}
                  >
                    <i className="bi bi-apple" style={{ fontSize: 20 }}></i>
                    Download iOS App
                  </a>
                )}
              </div>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={12}>
              <p className="f-12 text-center">
                If you are a {process.env.REACT_APP_SITE_NAME} team member, please{" "}
                <Link className="theme-link" to={login}>Login.</Link>
              </p>
            </Col>
          </Row>
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default UserRegister;
